export enum ProjectStatus {
    Possible = 1,
    Decided = 2,
    Approved = 3
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_entities/project-status.ts